import React from 'react';
import PropTypes from 'prop-types';

import { MultiSelect, useFormContext } from '@metarouter-private/mr-mui';

const PIPELINE_IDS_FIELD = 'pipelineIds';

export default function PipelineMultiSelect({ pipelines }) {
  const { watch, setValue } = useFormContext();
  const selectedPipelineIds = watch(PIPELINE_IDS_FIELD) ?? [];

  const options = pipelines.map(pipeline => ({
    label: pipeline.name,
    value: pipeline.id,
  }));

  const handleChange = selectedValues => {
    setValue(PIPELINE_IDS_FIELD, selectedValues);
  };

  return (
    <MultiSelect label="Pipelines" options={options} value={selectedPipelineIds} onChange={handleChange} size="small" />
  );
}

PipelineMultiSelect.propTypes = {
  pipelines: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};
